import React from 'react';
import { Box, Stack } from '@mui/material';
import { createSx } from '../../../../utils';

const sx = createSx({
  root: theme => ({
    ...theme.typography.caption,
    height: 'inherit',
    alignItems: 'center',
    px: 1,
    color: 'neutral.onSurfaceVariant'
  }),
  line: {
    flex: 1,
    height: '1px',
    backgroundColor: 'neutral.outlineVariant',
  }
});

interface Props {
  children: React.ReactNode;
  testID?: string;
}

const GroupTitle = ({ children, testID }: Props) => {
  return (
    <Stack sx={sx.root} direction='row' spacing={1} data-test-id={testID}>
      <Box>
        {children}
      </Box>
      <Box sx={sx.line} />
    </Stack>
  );
};

export default GroupTitle;